<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    :disabled="loading"
    @submit.prevent="() => submitForm()"
  >
    <v-container fluid class="pa-0">
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            v-model="formFields.user"

            name="user"
            required

            label="Usuário ou email"
            :rules="[vRules.requiredField]"
          />
        </v-col>

        <v-col cols="12">
          <password-field
            v-model="formFields.password"

            name="password"
            required

            label="Senha"
            :rules="[vRules.requiredField]"
          />
        </v-col>
      </v-row>

      <v-row dense justify="space-between">
        <v-col cols="12" sm="auto" order-sm="2">
          <v-btn
            block
            color="primary"
            type="submit"

            :loading="loading"
            :disabled="!isFormValid"
          >
            Entrar
          </v-btn>
        </v-col>

        <v-col cols="12" sm="auto" order-sm="1" class="d-flex align-center">
          <v-btn
            text
            block
            small
            color="primary"

            :disabled="loading"
            to="/password/forgot"
          >
            Esqueci a senha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { requiredField } from '@/utils/validators';
import PasswordField from '@/components/PasswordField.vue';

export default {
  name: 'LocalLoginForm',

  components: {
    PasswordField,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isFormValid: false,

    formFields: {
      user: '',
      password: '',
    },

    vRules: {
      requiredField,
    },
  }),

  methods: {
    submitForm() {
      this.$emit('submit', { ...this.formFields });
    },
  },
};
</script>
